/**
 * A hook that returns [[FetchingStatus]] and `searchTerm`.
 *
 * @ignore
 */
import { useSelector } from '../actions/types';
import * as selectors from '../selectors';
/**
 * # useSearchPageData
 */
export function useSearchPageData() {
    const searchTerm = useSelector(selectors.page.searchTerm);
    const fetchingStatus = useSelector((state) => selectors.page.searchPageFetchingStatus(state, searchTerm || ''));
    return {
        fetchingStatus,
        searchTerm,
    };
}
//# sourceMappingURL=useSearchPageData.js.map